import { render, staticRenderFns } from "./CompetitionEmptyDefaultLayout.vue?vue&type=template&id=1364e0b4&scoped=true&"
import script from "./CompetitionEmptyDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./CompetitionEmptyDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1364e0b4",
  null
  
)

export default component.exports